module.exports = __webpack_public_path__ + "static/illustration-2f0255ce44ebbe9016f9ad460f1735f6.jpg";